import { render, staticRenderFns } from "./WebsiteDepartmentForm.vue?vue&type=template&id=0ea0d053&"
import script from "./WebsiteDepartmentForm.vue?vue&type=script&lang=js&"
export * from "./WebsiteDepartmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports